import * as React from "react";
import type { SVGProps } from "react";
const SvgMail01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m3.6 6.104 8.4 5.4 9-5.4M4.8 19.096a2.4 2.4 0 0 1-2.4-2.4V7.304a2.4 2.4 0 0 1 2.4-2.4h14.4a2.4 2.4 0 0 1 2.4 2.4v9.392a2.4 2.4 0 0 1-2.4 2.4z"
    />
  </svg>
);
export default SvgMail01;
